import * as React from 'react'

const SvgMatchAboutIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1667 10.8333H3.83333M20.1667 10.8333C21.4553 10.8333 22.5 11.878 22.5 13.1667V20.1667C22.5 21.4553 21.4553 22.5 20.1667 22.5H3.83333C2.54467 22.5 1.5 21.4553 1.5 20.1667V13.1667C1.5 11.878 2.54467 10.8333 3.83333 10.8333M20.1667 10.8333V8.5C20.1667 7.21134 19.122 6.16667 17.8333 6.16667M3.83333 10.8333V8.5C3.83333 7.21134 4.878 6.16667 6.16667 6.16667M6.16667 6.16667V3.83333C6.16667 2.54467 7.21134 1.5 8.5 1.5H15.5C16.7887 1.5 17.8333 2.54467 17.8333 3.83333V6.16667M6.16667 6.16667H17.8333"
      stroke="url(#paint0_linear_1081_3128)"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1081_3128"
        x1="3.32609"
        y1="2.71387"
        x2="16.4146"
        y2="18.0394"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.135417" stopColor="#FF692E" />
        <stop offset="1" stopColor="#FF692E" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgMatchAboutIcon
